export const state = () => ({
    sectionTitle: '',
    jobUuid: '',
    currentVerticalScroll: 0,
});
